import getItemAltId from 'helpers/getItemAltId'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {nest} from 'recompose'
import {getId, getType} from "../../apis/model/base";
import {LayoutContext} from "../../components/layouts/Default/LayoutContext";
import {GoDotFill} from "react-icons/go";

const SmallFeedView = ({ item, className }) => {
    const {isSm} = useContext(LayoutContext)
    return (
        <Link
            key={item.id}
            to={{pathname: `/news/${getType(item)}/${getId(item)}`}}
            className="space-x-1 text-color-100 no-underline leading-tight italic">
            <GoDotFill size={9} className="text-color-500"/>
            <span className="font-medium text-doc-sm leading-relaxed-2 break-all min-w-0 overflow-hidden">
    {_.truncate(
        _.get(item, 'overview.title')?.trim()
            ? _.get(item, 'overview.title')
            : _.get(item, 'overview.description'),
        { length: 100 }
    )}
            </span>
        </Link>
    )
}

export const FeedMoreRecommends = nest(
    ({list, item}) => {
        const t = useTranslate()
        return (
            <div className="flex flex-col gap-2">
                {list.map((e, i) => (
                    <SmallFeedView
                        key={i}
                        item={e}
                    />
                ))}
                {!!item && (
                    <div className="w-full text-right flex justify-end">
                        <Link
                            to={`/${item._type}/${getItemAltId(item)}`}
                            className="text-color-500 italic text-xs no-underline">
                            {`${t('see more')}...`}
                        </Link>
                    </div>
                )}
            </div>
        )
    }
)
